import { render, staticRenderFns } from "./create_edit_source_material_modal.vue?vue&type=template&id=2321ec1a&"
import script from "./create_edit_source_material_modal.vue?vue&type=script&lang=js&"
export * from "./create_edit_source_material_modal.vue?vue&type=script&lang=js&"
import style0 from "./create_edit_source_material_modal.vue?vue&type=style&index=0&id=2321ec1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports